let configFromMemory = null;

const STORAGE_KEY = "app_config";

export async function loadConfig() {
  if (configFromMemory) {
    return configFromMemory;
  }

  const configFromSession = sessionStorage.getItem(STORAGE_KEY);
  if (configFromSession) {
    configFromMemory = JSON.parse(configFromSession);
    return configFromMemory;
  }

  const host = window.location.hostname.replace("www.", "");
  const url = host === "localhost"
    // ? "/config_ticket-portal.at-dev.coeo-group.ai.json" // local FE dev with remote BE
    ? "/config_ticket-portal.local.json" // local FE dev with local BE
    : `/config_${host}.json`;

  const response = await fetch(
    url, 
    {
        cache: "no-store"
    });

  if (!response.ok) {
    throw new Error(`Config not found: ${url}`);
  }

  const configFetched = await response.json();

  configFromMemory = configFetched;
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(configFetched));

  return configFromMemory;
}

export async function initConfig() {
  configFromMemory = await loadConfig();
  return configFromMemory;
}

export function getConfig() {
  if (!configFromMemory) {
    throw new Error("Config not initialized");
  }

  return configFromMemory;
}
